import { ReactElement } from 'react'
import { Grid } from '../../..'
import { Skeleton } from '../../../../Atoms'
import { StyledPartnerCardLoader } from './styles'

const PartnerCardLoader = (): ReactElement => (
    <StyledPartnerCardLoader>
        <Skeleton height={80} width={80} variant="circle" />
        <Grid gap={8}>
            <Skeleton />
            <Skeleton />
            <Skeleton width={80} />
        </Grid>
    </StyledPartnerCardLoader>
)

export default PartnerCardLoader

export { StyledPartnerCardLoader }
